import React from 'react';
import { OrderItem, TELE_CONSULT_ITEM_CODE, ConfirmModalState } from '../../types/dispense';

interface OrderPanelModalProps {
  show: boolean;
  orders: OrderItem[];
  totalAmount: number;
  isPatientPicked: boolean;
  setShow: (show: boolean) => void;
  setShowItemModal: (show: boolean) => void;
  onEditOrder: (order: OrderItem) => void;
  onRemoveItem: (id: number) => void;
  setConfirmModal: (modal: ConfirmModalState) => void;
}

export function OrderPanelModal({
  show, orders, totalAmount, isPatientPicked,
  setShow, setShowItemModal, onEditOrder, onRemoveItem, setConfirmModal
}: OrderPanelModalProps) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={() => setShow(false)}>
      <div className="order-modal" onClick={(e) => e.stopPropagation()}>
        <div className="order-modal-header">
          <div className="panel-title" style={{ margin: 0 }}>Current Orders ({orders.length})</div>
          <button className="order-modal-close" onClick={() => setShow(false)}>&times;</button>
        </div>
        <div className="order-list">
          {orders.map(order => {
            const isTeleConsult = order.code === TELE_CONSULT_ITEM_CODE;
            const canEdit = !isTeleConsult && isPatientPicked;
            return (
              <div
                key={order.id}
                className="order-item"
                onClick={() => { if (canEdit) onEditOrder(order); }}
                style={{
                  cursor: canEdit ? 'pointer' : isTeleConsult ? 'default' : 'not-allowed',
                  opacity: canEdit || isTeleConsult ? 1 : 0.6
                }}
              >
                <div className="order-item-info">
                  <div className="order-item-name">
                    {order.publishName || order.name}
                    {isTeleConsult && <span style={{ marginLeft: 6, fontSize: 10, color: '#64748b', fontWeight: 'normal' }}>(Auto)</span>}
                  </div>
                  <div className="order-item-details">
                    {order.type === 'MED' && order.dosage && order.frequency && (
                      <span>{order.dosage} {order.doseUOM || 'tablet'} {order.frequency} • </span>
                    )}
                    <span>Qty: {order.quantity || order.qty || 1} {order.dispenseUOM || 'unit'}</span>
                  </div>
                </div>
                <span className="order-item-price">${((order.unitPrice || order.price) * (order.quantity || order.qty || 1)).toFixed(2)}</span>
                {!isTeleConsult && (
                  <button
                    className="order-item-remove"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!isPatientPicked) return;
                      setConfirmModal({
                        show: true,
                        message: `Remove ${order.publishName || order.name} from orders?`,
                        onConfirm: () => {
                          onRemoveItem(order.id);
                          setConfirmModal({ show: false, message: '', onConfirm: () => {} });
                        },
                        onCancel: () => {
                          setConfirmModal({ show: false, message: '', onConfirm: () => {} });
                        }
                      });
                    }}
                    disabled={!isPatientPicked}
                    title="Remove item"
                    style={{
                      opacity: isPatientPicked ? 1 : 0.6,
                      cursor: isPatientPicked ? 'pointer' : 'not-allowed'
                    }}
                  >&times;</button>
                )}
              </div>
            );
          })}
        </div>
        <div className="order-total">
          <span>Total</span>
          <span className="order-total-amount">${totalAmount.toFixed(2)}</span>
        </div>
        <button
          className="btn btn-primary"
          style={{
            width: '100%', marginTop: 16,
            opacity: isPatientPicked ? 1 : 0.6,
            cursor: isPatientPicked ? 'pointer' : 'not-allowed'
          }}
          onClick={() => setShowItemModal(true)}
          disabled={!isPatientPicked}
        >
          + Add More Items
        </button>
      </div>
    </div>
  );
}
